<div class="content-wrapper">
    <div class="content-body">
        <section id="package">
            <ng-template #content>
                <div id="modal">
                    <div class="modal-header font-weight-bold">
                        <h4 class="modal-title font-weight-bold">Change Order Status
                            - {{this.orderStatus?.invoice_no}}</h4>
                        <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                (click)="modalService.dismissAll('')"
                        >
                            ×
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <form class="form" novalidate [formGroup]="updateOrderForm">
                                    <div class="px-3 container">
                                        <div class="row">
                                            <div class="col-12">
                                                <div class="form-group">
                                                    <label for="password" class="d-flex">
                                                        Order Status
                                                    </label>
                                                    <select class="form-control" id="password"
                                                            formControlName="order_status">
                                                        <option value="">Select Order Status</option>
                                                        <option value="DELIVERED">Delivered</option>
                                                    </select>
                                                    <small *ngIf="submitted && updateOrderForm.get('order_status').hasError('required')"
                                                           class="text-danger">
                                                        Field is required.
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-success color-white pull-right" [disabled]="submitting"
                                (click)="updateOrderStatus()">
                            <i class="fas fa-pen-square mr-1" *ngIf="!submitting"></i>
                            <i class="fas fa-spinner fa-pulse mr-1" *ngIf="submitting"></i>Update
                        </button>
                    </div>
                </div>
            </ng-template>
            <div class="row">
                <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-xs-12">
                    <h2 class="mt-5px">My Orders</h2>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12">
                    <form class="form" novalidate [formGroup]="filterForm">
                        <div class="row">
                            <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                <fieldset class="form-group">
                                    <select class="form-control" formControlName="session_id">
                                        <option [value]="session.id" *ngFor="let session of sessions">
                                            {{session?.name}}
                                        </option>
                                    </select>
                                </fieldset>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="row search-card mb-5px">
                <div class="col-12">
                    <form class="form mt-2 mb--8px" novalidate [formGroup]="searchForm">
                        <div class="row">
                            <div class="col-md-2 col-lg-2 col-sm-2 col-xs-12">
                                <fieldset class="form-group">
                                    <input class="form-control" type="text" formControlName="invoice_no"
                                           placeholder="Invoice No.">
                                </fieldset>
                            </div>
                            <div class="col-md-2 col-lg-2 col-sm-2 col-xs-12">
                                <fieldset class="form-group">
                                    <input class="form-control" type="number" formControlName="total_amount"
                                           placeholder="Total Amount">
                                </fieldset>
                            </div>
                            <div class="col-md-2 col-lg-2 col-sm-2 col-xs-12">
                                <fieldset class="form-group">
                                    <select class="form-control" formControlName="order_status">
                                        <option value="">Select Order Status</option>
                                        <option value="PLACED">Placed</option>
                                        <option value="DISPATCHED">Dispatched</option>
                                        <option value="DELIVERED">Delivered</option>
                                        <option value="CANCELLED">Cancelled</option>
                                    </select>
                                </fieldset>
                            </div>
                            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 text-center">
                                <fieldset class="form-group">
                                    <input class="form-control" type="date" formControlName="start_date_time">
                                    <small>Order Placed Start Date</small>
                                </fieldset>
                            </div>
                            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 text-center">
                                <fieldset class="form-group">
                                    <input class="form-control" type="date" formControlName="end_date_time">
                                    <small>Order Placed End Date</small>
                                </fieldset>
                            </div>
                            <div class="col-md-2 col-lg-2 col-sm-2 col-xs-12 text-center">
                                <button class="btn btn-primary btn-block btn-raised color-white mr-2 users-btn"
                                        (click)="search()"
                                        [disabled]="submitting">
                                    <i class="fas fa-spinner fa-pulse mr-1" *ngIf="submitting"></i>Search
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <!--<div class="row">
                <div class="col-12">
                    <form class="form mt-2 mb&#45;&#45;8px" novalidate [formGroup]="filterForm">
                        <div class="row">
                            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12"></div>
                            <div class="col-md-3 col-lg-3 col-sm-3 col-xs-12">
                                <fieldset class="form-group">
                                    <label>Session</label>
                                    <select class="form-control" formControlName="session_id">
                                        <option [value]="session.id" *ngFor="let session of sessions">
                                            {{session?.name}}
                                        </option>
                                    </select>
                                </fieldset>
                            </div>
                            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                <fieldset class="form-group">
                                    <label>Start Date</label>
                                    <input class="form-control" type="date" formControlName="start_date_time">
                                </fieldset>
                            </div>
                            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                <fieldset class="form-group">
                                    <label>End Date</label>
                                    <input class="form-control" type="date" formControlName="end_date_time"
                                           (change)="get()">
                                </fieldset>
                            </div>
                        </div>
                    </form>
                </div>
            </div>-->
            <div class="row mt-3" *ngIf="myOrders && myOrders.length > 0; else noDataToShow">
                <div class="col-12">
                    <div class="card" *ngFor="let myOrder of myOrders; let i = index">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                    <span class="f_20 font-weight-bold">{{(pagination.page - 1) * (pagination.perpage ? pagination.perpage : 0) + i + 1}}
                                        .</span>
                                </div>
                                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 text-center mt-auto mb-auto">
                                    <span class="font-weight-bold text-italic f_15 text-blue cursor-pointer"
                                          (click)="openExternalUrl('stockist-my-order-invoice-pdf/' + myOrder?.session_id +'/'+myOrder?.unique_id)">{{myOrder?.invoice_no}}</span>
                                    <br>
                                    <small class="text-italic">Invoice No.</small>
                                </div>
                                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 text-center mt-auto mb-auto">
                                    <span class="font-weight-bold text-italic f_15">{{myOrder?.order_date_time}}</span>
                                    <br>
                                    <small class="text-italic">Order Placed At</small>
                                </div>
                                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 text-center mt-auto mb-auto">
                                    <span class="font-weight-bold text-italic f_15 text-blue"
                                          *ngIf="myOrder['order_status'] === 'PLACED'">Placed</span>
                                    <span class="font-weight-bold text-italic f_15 text-warning cursor-pointer"
                                          *ngIf="myOrder['order_status'] === 'DISPATCHED'"
                                          (click)="changeOrderStatus(content, myOrder)">Dispatched</span>
                                    <span class="font-weight-bold text-italic f_15 text-primary"
                                          *ngIf="myOrder['order_status'] === 'DELIVERED'">Delivered</span>
                                    <span class="font-weight-bold text-italic f_15 text-danger"
                                          *ngIf="myOrder['order_status'] === 'CANCELLED'">Cancelled</span>
                                    <br>
                                    <small class="text-italic" *ngIf="myOrder['order_status'] !== 'DISPATCHED'">Order
                                        Status</small>
                                    <small class="text-italic" *ngIf="myOrder['order_status'] === 'DISPATCHED'">Click to
                                        Update</small>
                                </div>
                                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 text-center mt-auto mb-auto">
                                    <div *ngIf="myOrder['order_status'] === 'DELIVERED'">
                                        <span class="font-weight-bold text-italic f_15 text-primary"
                                              *ngIf="myOrder['order_deliver_date_time']">{{myOrder?.order_deliver_date_time}}</span>
                                        <span class="font-weight-bold text-italic f_15"
                                              *ngIf="!myOrder['order_deliver_date_time']">-</span>
                                        <br>
                                        <small class="text-italic">Order Delivered At</small>
                                    </div>
                                    <div *ngIf="myOrder['order_status'] === 'DISPATCHED'">
                                        <span class="font-weight-bold text-italic f_15 text-warning"
                                              *ngIf="myOrder['order_dispatched_date_time']">{{myOrder?.order_dispatched_date_time}}</span>
                                        <span class="font-weight-bold text-italic f_15"
                                              *ngIf="!myOrder['order_dispatched_date_time']">-</span>
                                        <br>
                                        <small class="text-italic">Order Dispatched At</small>
                                    </div>
                                    <div *ngIf="myOrder['order_status'] === 'CANCELLED'">
                                        <span class="font-weight-bold text-italic f_15 text-danger"
                                              *ngIf="myOrder['order_cancel_date_time']">{{myOrder?.order_cancel_date_time}}</span>
                                        <span class="font-weight-bold text-italic f_15"
                                              *ngIf="!myOrder['order_cancel_date_time']">-</span>
                                        <br>
                                        <small class="text-italic">Order Cancelled At</small>
                                    </div>
                                    <div *ngIf="myOrder['order_status'] === 'PLACED'">
                                        <span class="font-weight-bold text-italic f_15 text-blue">-</span>
                                        <br>
                                        <small class="text-italic">Order Dispatched At</small>
                                    </div>
                                </div>
                                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 text-center mt-auto mb-auto">
                                    <span class="font-weight-bold text-italic f_15">&#8377;{{myOrder?.total_amount | IndianNumber}}</span>
                                    <br>
                                    <small class="text-italic">Total Amount</small>
                                </div>
                                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto cursor-pointer">
                                    <i class="fa fa-chevron-circle-down f_18 text-blue" aria-hidden="true"
                                       (click)="myOrder['open_status'] = !myOrder['open_status']"
                                       *ngIf="myOrder['open_status'] == false"></i>
                                    <i class="fa fa-chevron-circle-up f_18 text-blue" aria-hidden="true"
                                       (click)="myOrder['open_status'] = !myOrder['open_status']"
                                       *ngIf="myOrder['open_status'] == true"></i>
                                </div>
                            </div>
                            <div class="row mt-20px pb-20px background-light-grey"
                                 *ngIf="myOrder['products'] && myOrder['products'].length > 0 && myOrder['open_status']">
                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 p-10px shadow-bottom-1px background-lightest-grey">
                                    <div class="row mt-10px pl-50px pr-50px">
                                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 text-center mt-auto mb-auto">
                                            <span class="font-weight-bold">Contact Person Name</span>
                                        </div>
                                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 text-center mt-auto mb-auto">
                                            <span class="font-weight-bold f_15 cursor-pointer">Contact Person Phone</span>
                                        </div>
                                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12 text-center mt-auto mb-auto">
                                            <span class="font-weight-bold f_15 cursor-pointer">Address</span>
                                        </div>
                                        <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                            <span class="font-weight-bold f_15 cursor-pointer">City</span>
                                        </div>
                                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 text-center mt-auto mb-auto">
                                            <span class="font-weight-bold f_15 cursor-pointer">State</span>
                                        </div>
                                        <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                            <span class="font-weight-bold f_15 cursor-pointer">Pin Code</span>
                                        </div>
                                        <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                            <span class="font-weight-bold f_15 cursor-pointer">GSTIN</span>
                                        </div>
                                    </div>
                                    <div class="row mt-20px pl-50px pr-50px">
                                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 text-center mt-auto mb-auto">
                                            <span class="text-italic">{{myOrder?.contact_person_name}}</span>
                                        </div>
                                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 text-center mt-auto mb-auto">
                                            <span class="text-italic f_15">{{myOrder?.contact_person_contact}}</span>
                                        </div>
                                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12 text-center mt-auto mb-auto">
                                            <span class="text-italic f_15">{{myOrder?.address}}</span>
                                        </div>
                                        <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                            <span class="text-italic f_15">{{myOrder?.city}}</span>
                                        </div>
                                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 text-center mt-auto mb-auto">
                                            <span class="text-italic f_15">{{myOrder?.state?.name}}</span>
                                        </div>
                                        <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                            <span class="text-italic f_15">{{myOrder?.pin_code}}</span>
                                        </div>
                                        <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                            <span class="text-italic f_15" *ngIf="myOrder?.gst_no">{{myOrder?.gst_no}}</span>
                                            <span class="text-italic f_15" *ngIf="!myOrder?.gst_no">-</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-20px">
                                    <div class="row mt-10px pl-50px pr-50px">
                                        <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                            <span class="font-weight-bold">S.No.</span>
                                        </div>
                                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 text-center mt-auto mb-auto">
                                            <span class="font-weight-bold f_15 cursor-pointer">Product</span>
                                        </div>
                                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 text-center mt-auto mb-auto">
                                            <span class="font-weight-bold f_15 cursor-pointer">Quantity</span>
                                        </div>
                                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 text-center mt-auto mb-auto">
                                            <span class="font-weight-bold f_15 cursor-pointer">HSN</span>
                                        </div>
                                        <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                            <span class="font-weight-bold f_15 cursor-pointer">Tax</span>
                                        </div>
                                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12 text-center mt-auto mb-auto">
                                            <span class="font-weight-bold f_15 cursor-pointer">Price</span>
                                        </div>
                                        <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                            <span class="font-weight-bold f_15 cursor-pointer">Total</span>
                                        </div>
                                    </div>
                                    <div class="row mt-20px pl-50px pr-50px"
                                         *ngFor="let product of myOrder['products']; let j = index">
                                        <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                            <span class="text-italic">{{(pagination.page - 1) * (pagination.perpage ? pagination.perpage : 0) + j + 1}}
                                                .</span>
                                        </div>
                                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 text-center mt-auto mb-auto">
                                            <span class="mr-10px">
                                                <img class="border-radius-50-per"
                                                     [src]="imageBaseUrl+product?.image_url"
                                                     width="50px" height="50px" [alt]="product?.name"/>
                                            </span>
                                            <span class="text-italic f_15 cursor-pointer">{{product?.name}}</span>
                                        </div>
                                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 text-center mt-auto mb-auto">
                                            <span class="text-italic f_15">{{product?.quantity}}</span>
                                        </div>
                                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 text-center mt-auto mb-auto">
                                            <span class="text-italic f_15">{{product?.hsn}}</span>
                                        </div>
                                        <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                            <span class="text-italic f_15">{{product?.tax}}%</span>
                                        </div>
                                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12 text-center mt-auto mb-auto">
                                            <span class="text-italic f_15">
                                                &#8377; {{product?.price | IndianNumber}}
                                                <small>(&#8377;{{product?.distributed_price | IndianNumber}}
                                                    / Unit)</small>
                                            </span>
                                        </div>
                                        <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                            <span class="text-italic f_15">&#8377; {{product?.total | IndianNumber}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ng-template #noDataToShow>
                <div class="row mt-3">
                    <div class="col-12">
                        <div class="card p-50px">
                            <div class="card-body text-center">
                                <div class="row">
                                    <div class="col-12">
                                        <i class="fa fa-shopping-cart fa-3x" aria-hidden="true"></i>
                                    </div>
                                    <div class="col-12 text-center">
                                        No orders to show
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
            <div class="row pagination-table">
                <ngb-pagination class="pagination-primary" [collectionSize]="pagination.total"
                                [(page)]="pagination.page" [boundaryLinks]="true"
                                [pageSize]="pagination.perpage" [maxSize]="5"
                                (pageChange)="onPageChange($event)">
                    <ng-template ngbPaginationPrevious>
                        <span [data-feather]="'chevron-left'" [size]="18"
                              [class]="'font-weight-bolder'">
                        </span>
                    </ng-template>
                    <ng-template ngbPaginationNext>
                        <span [data-feather]="'chevron-right'" [size]="18"
                              [class]="'font-weight-bolder'">
                        </span>
                    </ng-template>
                </ngb-pagination>
            </div>
        </section>
    </div>
</div>
